import { formatDistanceToNow } from "date-fns";

export function formatRelativeDate(dateString) {
  if (!dateString) return "";
  return formatDistanceToNow(new Date(dateString), { addSuffix: true });
}
